<div class="background-container">
  <div class="container-sm">
    <mpro-login-header [title]="'Sign in to World Data Pro'"></mpro-login-header>
    <form [formGroup]="form">
      <input type="login" class="form-control" placeholder="Email" formControlName="username">
      <div class="flex">
        <input class="form-control" [type]="passwordType" placeholder="Password" formControlName="password">
        <button type="button" tabindex="2" (click)="setPasswordType()" class="mpro-btn mpro-btn-icon"><fa-icon [icon]="faEye"></fa-icon></button>
      </div>
      <div *ngIf="errorMsg" class="error">
        <span>{{ errorMsg }}</span>
      </div>
      <p class="forgot-password">
        <a class="nostyle" tabindex="1" routerLink="/forgotten-password">Forgot password?</a>
      </p>
      <button id="big-button" type="submit" (click)="login()" [class.active]="form.valid">LOG IN</button>
      <p class="forgot-password mt-2 mb-0">
        Don't have an account? <a class="nostyle" tabindex="1" routerLink="/freemium/register">Sign up</a>
      </p>
    </form>
  </div>
</div>
